import React from "react";
import { FileText } from "lucide-react";
import { StaticPage, Block } from "../components/StaticPage";

const TermsPage = () => (
  <StaticPage icon={FileText} title="Conditions générales" testid="terms-page"
    intro="Conditions générales de vente (CGV) applicables aux commandes passées sur KTSauto.">
    <Block title="1. Objet">
      <p>Les présentes conditions régissent les ventes de pièces et accessoires automobiles conclues entre
      KTSauto et ses clients sur le site ktsauto.fr.</p>
    </Block>
    <Block title="2. Prix">
      <p>Les prix sont indiqués en euros TTC, hors frais de livraison. KTSauto se réserve le droit de modifier
      ses prix à tout moment, les articles étant facturés sur la base des tarifs en vigueur au moment de la commande.</p>
    </Block>
    <Block title="3. Commande">
      <p>Toute commande vaut acceptation des présentes conditions. Un email de confirmation récapitulant la commande
      est adressé au client après validation du paiement.</p>
    </Block>
    <Block title="4. Paiement">
      <p>Le paiement s'effectue en ligne par carte bancaire (CB, Visa, Mastercard) ou via PayPal, de manière sécurisée.
      La commande est expédiée après encaissement.</p>
    </Block>
    <Block title="5. Garantie légale">
      <p>Tous nos produits bénéficient de la garantie légale de conformité et de la garantie contre les vices cachés,
      conformément aux articles L.217-4 et suivants du Code de la consommation.</p>
    </Block>
    <Block title="6. Droit de rétractation">
      <p>Conformément à la loi, vous disposez d'un délai de 14 jours pour exercer votre droit de rétractation.
      Voir la rubrique « Livraison & retours ».</p>
    </Block>
  </StaticPage>
);

export default TermsPage;
